import { socketAsFetch } from 'utils/socket-as-fetch';

const SET_POST_FTUX_TYPE: string = 'set_post_ftux';

export type SetPostFtuxPayload = {
  [key: string]: boolean;
};

export const setPostFtux = (payload: SetPostFtuxPayload) =>
  socketAsFetch({
    message_type: SET_POST_FTUX_TYPE,
    info: payload,
  });
